import React from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';
import {applyMiddleware, createStore} from 'redux';
import thunk from 'redux-thunk';
import { ConfigProvider } from 'antd';
import rootReducer from './reducers';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './index.css';

const store = createStore(
  rootReducer,
  applyMiddleware(thunk)
);

render(
  <Provider store={store}>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#D65C5C',
          colorLink: '#D65C5C',
          colorText: '#100F2E',
          fontFamily: 'Bai Jamjuree, sans-serif',
          fontSize: 16,
          borderRadius: 8,
        },
      }}
    >
      <App />
    </ConfigProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

